import ReportRouter from './component'
export default ReportRouter
